import { Space } from 'antd'
import styled from 'styled-components'

const FullWidthSpace = styled(Space)`
  width: 100%;
`

export default FullWidthSpace
